import { useEffect, useState } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import printerimg from "../../../../assets/print.png";
import { useGetItemDetailsDataMutation } from "../../../../store/api/itemapi";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";
import FileAttachmentManagerViewPage  from "../../../../Components/FileAttachmentManagerViewPage";
import Attachment from "../../../../utils/Attachment";
const ViewForm = () => {
  const navigate = useNavigate();
   const location = useLocation();
        const IdData = location.state?.ItemId;
        const [podata, setpodata] = useState('')
  const [tab, settab] = useState(1);
  const [podate, setpodate] = useState(new Date().toISOString().split("T")[0]);
  const [error, setError] = useState("");
  const [ptype, setptype] = useState("Error");
  const [finalstep, setfinalstep] = useState(false);
  const [showError, setShowError] = useState(false);


  // tab1
  const [TemplateName, setTemplateName] = useState("");
  const [AllocatePaymentBasedOnPaymentTerms, setAllocatePaymentBasedOnPaymentTerms] = useState("");
  const [selected_payment_term_data, setselected_payment_term_data] = useState([]);

  const [po_response, setpo_response] = useState("");

  const [fieldErrors, setFieldErrors] = useState({
   TemplateName: false,
  });

  

const [AttachmentsList, setAttachmentsList] = useState([]); // ✅ Make sure it's an array
const [itemDetails, { data, isLoadin }] = useGetItemDetailsDataMutation();
 
     useEffect(() => {
         if (IdData) {
             itemDetails({ doctype: 'Payment Terms Template', name: IdData })
                 .unwrap()
                  .then((response) => {
                     const item = response.docs?.[0]; // ✅ safely access first item
  const docinfo = response.docinfo;

  if (!item) return;
                       setpodata(response)
                       console.log(item.terms, "Api response");
                       setTemplateName(item.template_name);
                       setAllocatePaymentBasedOnPaymentTerms(item.allocate_payment_based_on_payment_terms);
                       setselected_payment_term_data(item.terms);
                        setAttachmentsList(docinfo.attachments); // ✅ Correct place
                   })
                 .catch((err) => {
                     console.error('API Error:', err);
                 });
         } else {
             console.warn('No Id Data found in location state');
         }
     }, [IdData, itemDetails]);

  return (
    <FormLayout
      title="View Payment Terms Template"
      breadcrumbs={[
        { label: "Payment Terms Template"},
        { label: "Payment Terms Template List", url: "/master/payment-term-template/payment-term-template-list" },
      ]}
      status={'hide'}
      finalStep={finalstep}
      actionButtons={
        <>
          

          <Button
            to="/"
            className="px-2"
            imgSrc={printerimg}
            imgStyle={{ width: "21px" }}
          />
        </>
      }
    >
      <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff",flexGrow:'1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
          <div className="d-flex justify-content-between align-items-end ">
            <ul
              className="nav nav-tabs"
              style={{ color: "white", border: "none" }}
            >
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 1
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => {
                    settab(1);
                  }}
                  href="#"
                >
                  General Details
                  {tab == 1 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
            </ul>

            {/* <FileAttachmentManagerViewPage
  doctype="Payment Terms Template"
  docname={IdData}
  attachments={AttachmentsList}
  setAttachments={setAttachmentsList}
/> */}

         <Attachment doctype="Payment Terms Template"  docname={IdData}  />    

          </div>
        </div>

        <div
          className="mt-2"
          style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff" }}
        >
          <div
            className="mt-2 py-2"
            style={{
              width: "100%",
              overflow: "hidden",
              backgroundColor: "#fff",
            }}
          >
            <div className="row d-flex justify-content-between">
              <div className="col-12">
                <div className="sidebarbox m-0 px-4 py-2">
                  <Tab1
                  IdData={IdData}
  setselected_payment_term_data={setselected_payment_term_data}
                      selected_payment_term_data={selected_payment_term_data}
                    TemplateName={{
                      TemplateName: TemplateName,
                      setTemplateName: setTemplateName,
                      TemplateName: TemplateName,
                      Error: fieldErrors.TemplateName,
                    }}
  
                    AllocatePaymentBasedOnPaymentTerms={{
                      AllocatePaymentBasedOnPaymentTerms: AllocatePaymentBasedOnPaymentTerms,
                      setAllocatePaymentBasedOnPaymentTerms: setAllocatePaymentBasedOnPaymentTerms,
                      AllocatePaymentBasedOnPaymentTerms: AllocatePaymentBasedOnPaymentTerms,
                      Error: fieldErrors.AllocatePaymentBasedOnPaymentTerms,
                    }}
                    
                    
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </FormLayout>
  );
};

export default ViewForm;
